export default "__VITE_ASSET__CAxTjIu$__"